import * as engine from "./engine.js";
import * as book from "./book.js";
import * as repertoire from "./repertoire.js";
import * as boardNav from "./boardNav.js";

/**
 * Central position change handler.
 * Called whenever the board position changes (user move, load line, form change, etc.)
 * Each module writes to the store; UI subscribes and reacts.
 *
 * @param {Object} options
 * @param {boolean} [options.autoPlay=false] - Whether to auto-play opponent's move from book
 */
export function onPositionChanged({ autoPlay = false } = {}) {
    engine.evaluatePosition();
    book.loadBookForCurrentPosition(autoPlay);
    book.loadMyMovesForCurrentPosition();
    repertoire.checkRepertoire();
    boardNav.updateStatus();
}
